import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getPowerGenerationRegisterStatusList as getPowerGenerationRegisterStatusListApi,
	getPowerGenerationRegisterStatus as getPowerGenerationRegisterStatusApi,
	getPowerGenerationRegisterStatusCode as getPowerGenerationRegisterStatusCodeApi,
	addNewPowerGenerationRegisterStatus as addNewPowerGenerationRegisterStatusApi,
	updatePowerGenerationRegisterStatus as updatePowerGenerationRegisterStatusApi,
	deletePowerGenerationRegisterStatus as deletePowerGenerationRegisterStatusApi,
} from '../../helpers/establishment/backend_helper';

export const getPowerGenerationRegisterStatusList = createAsyncThunk('powerGenerationRegisterStatus/getPowerGenerationRegisterStatusList', async () => {
	try {
		const response = getPowerGenerationRegisterStatusListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPowerGenerationRegisterStatus = createAsyncThunk('powerGenerationRegisterStatus/getPowerGenerationRegisterStatus', async powerGenerationRegisterStatus_id => {
	try {
		const response = getPowerGenerationRegisterStatusApi(powerGenerationRegisterStatus_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPowerGenerationRegisterStatusCode = createAsyncThunk('powerGenerationRegisterStatus/getPowerGenerationRegisterStatusCode', async code => {
	try {
		const response = getPowerGenerationRegisterStatusCodeApi(code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewPowerGenerationRegisterStatus = createAsyncThunk('powerGenerationRegisterStatus/addNewPowerGenerationRegisterStatus', async powerGenerationRegisterStatus => {
	try {
		const response = addNewPowerGenerationRegisterStatusApi(powerGenerationRegisterStatus);
		toast.success('Estado de registroagregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar powerGenerationRegisterStatus.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updatePowerGenerationRegisterStatus = createAsyncThunk('powerGenerationRegisterStatus/updatePowerGenerationRegisterStatus', async (powerGenerationRegisterStatus) => {
		try {
			const response = updatePowerGenerationRegisterStatusApi(powerGenerationRegisterStatus);
			toast.success('Estado de registroactualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar powerGenerationRegisterStatus.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deletePowerGenerationRegisterStatus = createAsyncThunk('powerGenerationRegisterStatus/deletePowerGenerationRegisterStatus', async powerGenerationRegisterStatus => {
	try {
		const response = await deletePowerGenerationRegisterStatusApi(powerGenerationRegisterStatus);
		toast.success('Estado de registroeliminado exitosamente.', { autoClose: 3000 });
		return { powerGenerationRegisterStatus, ...response };
	} catch (error) {
		toast.error('Error al eliminar powerGenerationRegisterStatus.', { autoClose: 3000 });
		throw new Error(error);
	}
});


